import {useState} from 'react';
import Row from "../_common/form/Row";
import Col from "../_common/form/Col";
import Button from "../_common/form/Button";
import QRCode from '../_common/api/QRCode';
import { HamQuest } from '../../App';
import Modal from '../_common/Modal';
import { QuestRoute } from '../_common/api/QuestRoutes';
import Input from '../_common/form/Input';
import Form from '../_common/form/Form';
import { Regex } from '../_common/api/regex';

const TimeBank = ({ ...props }) => {
const [token, setToken] = useState("");

    const TimeForm = (type) => {
        return (
            <Form
                inputs={{
                    TempIdType: type.type,
                    minutes: 5
                }}
                onSubmit={(e) => {
                    if(e.minutes <= type.balance) {
                    HamQuest.post(QuestRoute.tempToken, {
                        TempIdType: type.type,
                        minutes: e.minutes
                    })
                    .then(res => 
                    {
                    if (!res.tempId) throw res.error;
                    setToken(res.tempId);
                    Modal.Show({
                        title: 'Time Bank QR Code',
                        body: (
                            <Col>
                                <QRCode data={token} />
                            </Col>
                        ),})})
                    .catch(ex => {
                        Modal.Show({
                            type: 'error',
                            title: 'Unable to Generate QR Code',
                        });
                    });}
                }}
                submitButton='Make Code'
                submittingButton='Making Code'
                localForm
            >
                <Input
                    label='Minutes'
                    name='minutes'
                    type='number'
                    max = {type.balance}
                    required
                    validate={Regex.test.int}
                />
            </Form>
        )
    }


        const handleMinutesModal = (type) => {
        Modal.Show({
            title: 'Time Bank',
            body: TimeForm(type),
            icon: 'clock'
        })
        }

    return (
        <div className='time-bank'>
            {props.banks.map((bank, index) => (
                <div key={index} className='time-bank-item'>
                    <h3>{bank.type}</h3>
                    <Row>
                        <p>Balance: {bank.balance} minutes</p>
                        <Button onClick={() =>handleMinutesModal(bank)}>Use time</Button>
                    </Row>
                    
                </div>
            ))}
        </div>
    );
}
export default TimeBank;